import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import config from "../../config.json";
import Moment from "react-moment";
import { calculateIndex } from "./paginate";
import Help from "./Help";
import Pagination from "../../comman/pagination";
import PageSizeOptions from "../PageSizeOptions";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentSupportWorkflowTask,
  getStartedSupportAppData,
  getSupportBprmForm,
  getSupportTickets,
  getSupportLoading,
  loadSupportBprmForm,
  loadSupportCurrentWorkflowTask,
  loadSupportTickets,
  sendSupportTicketsMessage,
  startSupportApplication,
  supportBprmFormReceived,
} from "../../app/store/support";
import { getCurrentUser } from "../../services/authService";
import { getFieldData } from "../../services/appService";
import WorkflowElement from "../../app/components/WorkflowElement";
import useDocDownload from "../../app/hooks/useDocDownload";
import MessagingPopUpMod from "../PortalForms/MessagingPopUpMod";

const SupportPupup = (props) => {
  const { issueShowHide, handleIssueShowHide } = props;

  const [activeTab, setActiveTab] = useState("tickets");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [totalCount, setTotalCount] = useState(5);

  const [supportTickets, setSupportTicketes] = useState([]);
  const [btnProcess, setBtnProcess] = useState(false);
  const [reqCount, setReqCount] = useState(0);
  const [workflowTask, setWorkflowTask] = useState(null);
  const [helpShowHide, setHelpShowHide] = useState(false);
  const [msgObj, setMsgObj] = useState(null);
  const [msgShowHide, setMsgShowHide] = useState(false);
  const [supObj, setSupObj] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  
  const [showHelpFirst, setShowHelpFirst] = useState(false);
  const [isInitializingApp, setIsInitializingApp] = useState(false);
  const [btnProceedLoading, setBtnProceedLoading] = useState(false);
  const [isRaisingTicket, setIsRaisingTicket] = useState(false);
  const [completedTaskId, setCompletedTaskId] = useState(null);

  const supportTicketsSelector = useSelector(getSupportTickets);
  const supportTicketsLoading = useSelector(getSupportLoading);
  const supportAppStartedDataSelector = useSelector(getStartedSupportAppData);
  const currentSupportWorkflowTaskSelector = useSelector(
    getCurrentSupportWorkflowTask
  );
  const supportBprmFormSelector = useSelector(getSupportBprmForm);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (issueShowHide && currentUser?.id) {
      dispatch(loadSupportTickets(currentUser.id, pageSize, currentPage));
    }
  }, [issueShowHide, dispatch, currentUser?.id, pageSize, currentPage]);

  useEffect(() => {
    if (issueShowHide) {
      setActiveTab("tickets");
      setMsgObj(null);
      setShowHelpFirst(false);
      setIsInitializingApp(false);
      setBtnProceedLoading(false);
      setIsRaisingTicket(false);
      setCompletedTaskId(null);
    }
  }, [issueShowHide]);

  useEffect(() => {
    if (supportTicketsSelector?.data?.length > 0) {
      setSupportTicketes(supportTicketsSelector.data);
      setTotalCount(supportTicketsSelector.totalCount);
      setWfForm(null);
      setWorkflowTask(null);
      setSupObj(null);
      setMsgObj(null);
      dispatch(supportBprmFormReceived(null));
    } else if (supportTicketsSelector?.data?.length === 0) {
      setSupportTicketes([]);
      setTotalCount(0);
    }
  }, [supportTicketsSelector, dispatch]);

  const handleRunApplication = () => {
    setCompletedTaskId(null);
    setBtnProcess(true);
    setIsRaisingTicket(true);
    setIsInitializingApp(true);
    setActiveTab("add_issue");

    const newApplication = {
      workflowId: config.WorkflowIds.SupportWorkfowId,
      performerId: parseInt(currentUser.id),
      applicationId: 1,
    };
    dispatch(startSupportApplication(newApplication));
    setHelpShowHide(false);

    setTimeout(() => {
      setIsInitializingApp(false);
      setShowHelpFirst(true);
    }, 2500);
  };

  const handleCloseAndProceed = () => {
    setBtnProceedLoading(true);
    setTimeout(() => {
      setBtnProceedLoading(false);
      setShowHelpFirst(false);
    }, 2000);
  };

  const handleCancelAddIssue = () => {
    setBtnProcess(false);
    setIsRaisingTicket(false);
    setIsInitializingApp(false);
    setBtnProceedLoading(false);
    setShowHelpFirst(false);
    setCompletedTaskId(null);
    setReqCount(0);
    setWorkflowTask(null);
    setWfForm(null);
    dispatch(supportBprmFormReceived(null));
    dispatch(loadSupportTickets(currentUser.id, pageSize, 1));
    setActiveTab("tickets");
  };

  useEffect(() => {
    if (supportAppStartedDataSelector?.ciid > 0) {
      setTimeout(() => {
        dispatch(loadSupportCurrentWorkflowTask(supportAppStartedDataSelector));
        setReqCount(1);
      }, 3000);
    }
  }, [supportAppStartedDataSelector, dispatch]);

  useEffect(() => {
    if (completedTaskId && currentSupportWorkflowTaskSelector?.wiid === completedTaskId) {
      return;
    }

    if (currentSupportWorkflowTaskSelector?.formId === null && reqCount <= 5) {
      setTimeout(async () => {
        dispatch(loadSupportCurrentWorkflowTask(supportAppStartedDataSelector));
        const rqCount = reqCount + 1;
        setReqCount(rqCount);
      }, 3000);
    } else if (currentSupportWorkflowTaskSelector?.wiid > 0) {
      setWorkflowTask(currentSupportWorkflowTaskSelector);
      dispatch(loadSupportBprmForm(currentSupportWorkflowTaskSelector.formId));
    } else if (reqCount === 0 || reqCount >= 3) {
      setReqCount(0);
      setWorkflowTask(null);
      setWfForm(null);
      dispatch(loadSupportTickets(currentUser.id, pageSize, 1));
      setBtnProcess(false);
    }
  }, [currentSupportWorkflowTaskSelector, dispatch, currentUser?.id, pageSize, supportAppStartedDataSelector, reqCount, completedTaskId]);

  const handleNextTask = (btnType) => {
    if (btnType === "taskCompleted") {
      if (workflowTask) {
        setCompletedTaskId(workflowTask.wiid);
      }
      setReqCount(0);
      setWorkflowTask(null);
      setWfForm(null);
      setIsRaisingTicket(false);
      dispatch(loadSupportTickets(currentUser.id, pageSize, 1));
      setBtnProcess(false);
      setActiveTab("tickets");
    } else {
      setTimeout(() => {
        dispatch(loadSupportCurrentWorkflowTask(workflowTask));
        setReqCount(1);
      }, 3000);
    }
  };

  useEffect(() => {
    if (supportBprmFormSelector) {
      setWfForm(supportBprmFormSelector);
      setBtnProcess(false);
    }
  }, [supportBprmFormSelector]);

  const handleMessagePopup = (msg) => {
    if (!msg) {
      setMsgObj(null);
      if (activeTab === "discussion") {
        setActiveTab("tickets");
      }
    } else {
      setSupObj(msg);
      const obj = { ...msg, id: msg.commId };
      setMsgObj(obj);
      setActiveTab("discussion");
    }
  };

  const handleSelectTicketRow = (item) => {
    setSupObj(item);
    const obj = { ...item, id: item.commId };
    setMsgObj(obj);
  };

  const handleHelpShowHide = async () => {
    setHelpShowHide(!helpShowHide);
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    dispatch(
      loadSupportTickets(currentUser.id, currentTarget.value, currentPage)
    );
  };

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(
      page,
      startIndex,
      endIndex
    );
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    dispatch(loadSupportTickets(currentUser.id, pageSize, page));
  };

  const handleSendMessage = () => { };

  const handleSupportMessage = (msg, msgObj) => {
    if (msg !== "") {
      const suppportObj = {
        id: supObj.ciid,
        message: msg,
        userId: parseInt(currentUser.id),
        commId: supObj.commId || 0,
        performerId: supObj.performerId || 0,
        ciid: supObj.ciid || 0,
        wiid: supObj.wiid || 0,
        iiid: supObj.iiid || 0,
        uploadId: msgObj?.docUploadId || 0,
      };
      dispatch(sendSupportTicketsMessage(suppportObj));
    }
  };

  return (
    <>
      <Modal
        show={issueShowHide}
        onHide={handleIssueShowHide}
        dialogClassName="rt-profile-modal theme-primary"
        centered
        backdrop="static"
      >
        <style>{`
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }
          .modal.fade .rt-profile-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .rt-profile-modal.modal-dialog {
            transform: scale(1) !important;
          }
          .rt-profile-modal {
            --task-accent: #2563eb;
            --task-soft: #eff6ff;
            width: min(1100px, calc(100vw - 64px)) !important;
            max-width: min(1100px, calc(100vw - 64px)) !important;
            height: auto !important;
          }
          .rt-profile-modal .modal-content {
            border-radius: 12px !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            max-height: calc(100vh - 60px) !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .rt-profile-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 24px 28px 20px 32px !important;
            background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }
          .rt-profile-modal .modal-header::before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            bottom: 0 !important;
            width: 4px !important;
            background: var(--task-accent) !important;
          }
          .rt-profile-modal .rt-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 14px !important;
            width: 100% !important;
          }
          .rt-profile-modal .rt-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 18px !important;
            width: 100% !important;
          }
          .rt-profile-modal .rt-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .rt-profile-modal .rt-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            min-width: 0 !important;
            padding-top: 4px !important;
          }
          .rt-profile-modal .rt-header-icon {
            width: 52px !important;
            height: 52px !important;
            min-height: 52px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: var(--task-accent) !important;
            background: #ffffff !important;
            border: 1px solid var(--task-accent) !important;
            box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }
          .rt-profile-modal .rt-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 18px !important;
            font-weight: 850 !important;
            line-height: 1.2 !important;
            min-width: 0 !important;
          }
          .rt-profile-modal .rt-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 12px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }
          .rt-profile-modal .rt-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 999px !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            background: var(--task-soft) !important;
            color: var(--task-accent) !important;
            border: 1px solid #e2e8f0 !important;
          }
          .rt-profile-modal .rt-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 10px 12px !important;
            margin-top: 0 !important;
            padding-left: 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
          }
          .rt-profile-modal .rt-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            padding: 5px 10px !important;
            border-radius: 8px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            border: 1px solid #e2e8f0 !important;
            box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
          }
          .rt-profile-modal .rt-meta-chip i {
            color: var(--task-accent) !important;
            font-size: 11px !important;
          }
          .rt-profile-modal .rt-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 40px !important;
            height: 40px !important;
            padding: 0 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .rt-profile-modal .rt-action-btn:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .rt-action-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
            transition: color 0.2s ease !important;
          }
          .rt-profile-modal .rt-action-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-profile-modal .modal-body {
            position: relative !important;
            padding: 18px 28px 28px !important;
            background: #ffffff !important;
            max-height: calc(100vh - 220px) !important;
            min-height: 0 !important;
            overflow-y: auto !important;
          }
          .rt-profile-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
            gap: 12px !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-profile-modal label,
          .rt-profile-modal .form-control-label {
            font-size: 11px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            text-transform: uppercase !important;
            letter-spacing: 0.7px !important;
            margin-bottom: 6px !important;
            display: flex !important;
            align-items: center !important;
            gap: 5px !important;
          }
          .rt-profile-modal .form-group {
            margin-bottom: 16px !important;
          }
          .rt-profile-modal .form-control {
            border-radius: 9px !important;
            border: 1.5px solid #e2e8f0 !important;
            padding: 8px 13px !important;
            font-size: 13px !important;
            color: #1e293b !important;
            background: #ffffff !important;
            transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
            width: 100% !important;
          }
          .rt-profile-modal .form-control:hover {
            border-color: #94a3b8 !important;
            box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
          }
          .rt-profile-modal .form-control:focus {
            border-color: var(--task-accent) !important;
            box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
            outline: none !important;
            background: #fafbff !important;
          }
          .rt-profile-modal .rt-password-submit-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #ffffff !important;
            background: var(--task-accent) !important;
            border: 1px solid var(--task-accent) !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 10px rgba(37, 99, 235, 0.2) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-profile-modal .rt-password-submit-btn:hover:not(:disabled) {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 6px 12px rgba(37, 99, 235, 0.3) !important;
          }
          .rt-profile-modal .rt-password-submit-btn:disabled {
            opacity: 0.6 !important;
            cursor: not-allowed !important;
            box-shadow: none !important;
          }
          .rt-profile-modal .badge-danger {
            background-color: #ef4444 !important;
            color: #ffffff !important;
          }
          .rt-profile-modal .badge-success {
            background-color: #10b981 !important;
            color: #ffffff !important;
          }
          .rt-profile-modal .rt-status-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 999px !important;
            font-size: 11px !important;
            font-weight: 750 !important;
            text-transform: uppercase !important;
          }
          .rt-profile-modal .rt-status-badge.fixed {
            background: #ecfdf5 !important;
            color: #059669 !important;
            border: 1.5px solid #d1fae5 !important;
          }
          .rt-profile-modal .rt-status-badge.pending {
            background: #fffbeb !important;
            color: #d97706 !important;
            border: 1.5px solid #fef3c7 !important;
          }
          /* ── Tabs Styling ─────────────────────────────── */
          .rt-profile-modal .wf-tab-bar {
            display: flex !important;
            align-items: stretch !important;
            gap: 4px !important;
            border-bottom: 2px solid #f1f5f9 !important;
            margin-bottom: 20px !important;
            padding: 8px 4px 0 !important;
            position: relative !important;
            flex: 0 0 auto !important;
          }
          .rt-profile-modal .wf-tab-btn {
            position: relative !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            border: none !important;
            background: transparent !important;
            padding: 9px 16px 11px !important;
            font-size: 13.5px !important;
            font-weight: 600 !important;
            color: #64748b !important;
            cursor: pointer !important;
            border-radius: 8px 8px 0 0 !important;
            transition: color 0.2s ease, background 0.2s ease !important;
            outline: none !important;
            white-space: nowrap !important;
          }
          .rt-profile-modal .wf-tab-btn i {
            font-size: 13px !important;
            transition: color 0.2s ease !important;
          }
          .rt-profile-modal .wf-tab-btn:hover {
            color: #1e293b !important;
            background: rgba(37,99,235,0.04) !important;
          }
          .rt-profile-modal .wf-tab-btn:focus,
          .rt-profile-modal .wf-tab-btn:focus-visible,
          .rt-profile-modal .wf-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-profile-modal .wf-tab-btn.active {
            color: #2563eb !important;
            font-weight: 700 !important;
          }
          .rt-profile-modal .wf-tab-btn.active i {
            color: #2563eb !important;
          }
          .rt-profile-modal .wf-tab-btn::after {
            content: "" !important;
            position: absolute !important;
            bottom: -2px !important;
            left: 0 !important;
            right: 0 !important;
            height: 2px !important;
            background: #2563eb !important;
            border-radius: 2px 2px 0 0 !important;
            transform: scaleX(0) !important;
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-profile-modal .wf-tab-btn.active::after {
            transform: scaleX(1) !important;
          }
          .rt-profile-modal .wf-tab-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            min-width: 20px !important;
            height: 20px !important;
            padding: 0 6px !important;
            border-radius: 999px !important;
            font-size: 11px !important;
            font-weight: 700 !important;
            background: #f1f5f9 !important;
            color: #64748b !important;
            border: 1px solid #e2e8f0 !important;
            transition: all 0.2s ease !important;
            line-height: 1 !important;
            margin-left: 2px !important;
          }
          .rt-profile-modal .wf-tab-btn.active .wf-tab-badge {
            background: rgba(37,99,235,0.1) !important;
            color: #1d4ed8 !important;
            border-color: rgba(37,99,235,0.2) !important;
          }
          @keyframes tabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          .rt-profile-modal .wf-tab-panel {
            animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
          }
          .rt-profile-modal .wf-empty-state {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 50px 24px !important;
            text-align: center !important;
            gap: 12px !important;
            animation: tabFadeIn 0.3s ease both !important;
          }
          .rt-profile-modal .wf-empty-icon {
            width: 52px !important;
            height: 52px !important;
            border-radius: 14px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 22px !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%) !important;
            border: 1px solid rgba(37,99,235,0.12) !important;
            color: #2563eb !important;
            margin-bottom: 4px;
          }
          .rt-profile-modal .wf-empty-title {
            font-size: 15px !important;
            font-weight: 700 !important;
            color: #1e293b !important;
            margin: 0 !important;
            text-align: center !important;
            width: 100% !important;
          }
          .rt-profile-modal .wf-empty-desc {
            font-size: 13px !important;
            color: #64748b !important;
            margin: 0 auto !important;
            line-height: 1.6 !important;
            text-align: center !important;
            width: 100% !important;
          }

          /* ── Table Styling matching WorkflowUser ──────── */
          .rt-profile-modal .wf-table-scroll {
            overflow: auto !important;
            scrollbar-width: thin;
            scrollbar-color: #cbd5e1 transparent;
            border-radius: 12px !important;
            border: 1px solid #e2e8f0 !important;
          }
          .rt-profile-modal .wf-table-scroll::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          .rt-profile-modal .wf-table-scroll::-webkit-scrollbar-track {
            background: transparent;
          }
          .rt-profile-modal .wf-table-scroll::-webkit-scrollbar-thumb {
            background-color: #cbd5e1;
            border-radius: 99px;
          }
          .rt-profile-modal .wf-table {
            width: 100% !important;
            border-collapse: separate !important;
            border-spacing: 0 !important;
            margin-bottom: 0 !important;
          }
          .rt-profile-modal .wf-thead {
            background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
            position: sticky !important;
            top: 0 !important;
            z-index: 2 !important;
          }
          .rt-profile-modal .wf-thead th {
            font-size: 11.5px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.6px !important;
            padding: 13px 16px !important;
            border-bottom: 2px solid #e2e8f0 !important;
            border-top: none !important;
            white-space: nowrap !important;
          }
          .rt-profile-modal .wf-table-row {
            transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
            animation: rowFadeIn 0.25s ease both !important;
          }
          .rt-profile-modal .wf-table-row:hover {
            background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
            box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.35) !important;
          }
          .rt-profile-modal .wf-table-row:active {
            transform: scaleY(0.99) !important;
          }
          .rt-profile-modal .wf-table td {
            padding: 13px 16px !important;
            font-size: 13px !important;
            color: #334155 !important;
            border-bottom: 1px solid #f1f5f9 !important;
            vertical-align: middle !important;
            transition: color 0.15s ease !important;
          }
          .rt-profile-modal .wf-table-row:hover td {
            color: #1e293b !important;
          }
          .rt-profile-modal .wf-table tbody tr:last-child td {
            border-bottom: none !important;
          }
          @keyframes rowFadeIn {
            from { opacity: 0; transform: translateY(4px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          /* ── Premium Badges matching WorkflowUser ──────── */
          .rt-profile-modal .badge-capsule {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 20px !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            line-height: 1 !important;
          }
          .rt-profile-modal .badge-unrestricted {
            background: #f1f5f9 !important;
            color: #475569 !important;
            border: 1px solid #cbd5e1 !important;
          }
          .rt-profile-modal .badge-count {
            background: rgba(79, 70, 229, 0.06) !important;
            color: #4f46e5 !important;
            border: 1px solid rgba(79, 70, 229, 0.12) !important;
            border-radius: 99px !important;
            font-size: 12.5px !important;
            padding: 4px 12px !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
          }
          .rt-profile-modal .badge-users {
            background: rgba(16, 185, 129, 0.08) !important;
            color: #047857 !important;
            border: 1px solid rgba(16, 185, 129, 0.15) !important;
          }
          .rt-profile-modal .badge-zero {
            background: #f1f5f9 !important;
            color: #64748b !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 99px !important;
            font-size: 12px !important;
            padding: 3px 10px !important;
            font-weight: 700 !important;
          }
          .rt-profile-modal .badge-danger-count {
            background: rgba(239, 68, 68, 0.08) !important;
            color: #dc2626 !important;
            border: 1px solid rgba(239, 68, 68, 0.15) !important;
          }
          
          /* ── Card Header Bar for Toolbar Row ── */
          .rt-profile-modal .wf-card-header-bar {
            position: relative !important;
            overflow: hidden !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            flex-wrap: wrap !important;
            gap: 12px !important;
            padding: 12px 20px !important;
            background: linear-gradient(90deg, #fafbfd 0%, #ffffff 100%) !important;
            border-radius: 12px !important;
            border: 1px solid #cbd5e1 !important;
            margin-bottom: 20px !important;
          }
          .rt-profile-modal .wf-header-left {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            flex-wrap: wrap !important;
          }
          .rt-profile-modal .wf-stats-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: rgba(16, 185, 129, 0.07) !important;
            border: 1px solid rgba(16, 185, 129, 0.18) !important;
            color: #047857 !important;
            border-radius: 999px !important;
            padding: 5px 12px !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            letter-spacing: 0.2px !important;
          }
          .rt-profile-modal .wf-stats-chip i {
            font-size: 11px !important;
          }

          /* ── Selected Context Card Styling ── */
          .rt-profile-modal .wf-assign-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 20px !important;
            padding: 16px 24px !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%) !important;
            border: 1px solid rgba(37,99,235,0.12) !important;
            border-radius: 14px !important;
            flex-wrap: wrap !important;
            animation: tabFadeIn 0.3s ease both !important;
          }
          .rt-profile-modal .wf-assign-actions {
            display: flex !important;
            gap: 8px !important;
            align-items: center !important;
            flex-wrap: wrap !important;
          }
          .rt-profile-modal .wf-assign-actions .btn-action-search {
            height: 38px !important;
            box-sizing: border-box !important;
            justify-content: center !important;
          }
          .rt-profile-modal .btn-action-search {
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 8px 16px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            color: #475569 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .rt-profile-modal .btn-action-search:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .btn-action-search.btn-primary-search {
            background: #2563eb !important;
            color: #ffffff !important;
            border-color: #2563eb !important;
          }
          .rt-profile-modal .btn-action-search.btn-primary-search:hover {
            background: #1d4ed8 !important;
            color: #ffffff !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
          }
          .rt-profile-modal .btn-action-search.btn-danger-search {
            background: rgba(239, 68, 68, 0.06) !important;
            color: #dc2626 !important;
            border: 1px solid rgba(239, 68, 68, 0.18) !important;
          }
          .rt-profile-modal .btn-action-search.btn-danger-search:hover {
            background: rgba(239, 68, 68, 0.12) !important;
            color: #b91c1c !important;
            border-color: rgba(239, 68, 68, 0.28) !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
          }
          .rt-profile-modal .wf-assign-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
          }
          .rt-profile-modal .wf-assign-avatar {
            width: 44px !important;
            height: 44px !important;
            border-radius: 12px !important;
            background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: white !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }
          .rt-profile-modal .wf-assign-meta strong {
            display: block !important;
            font-size: 14px !important;
            font-weight: 700 !important;
            color: #1e293b !important;
            margin-bottom: 3px !important;
          }
          .rt-profile-modal .wf-assign-meta span {
            font-size: 12px !important;
            color: #64748b !important;
            font-weight: 500 !important;
          }
          .rt-profile-modal .wf-table-row.selected-row {
            background: linear-gradient(90deg, rgba(37,99,235,0.07) 0%, rgba(37,99,235,0.02) 100%) !important;
            box-shadow: inset 4px 0 0 0 #2563eb !important;
          }
          .rt-profile-modal .wf-table-row.selected-row:hover {
            background: linear-gradient(90deg, rgba(37,99,235,0.1) 0%, rgba(37,99,235,0.04) 100%) !important;
          }
          .rt-profile-modal .wf-table-row.selected-row td {
            color: #1e3a8a !important;
            font-weight: 600 !important;
            border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
          }

          /* Shimmer Skeleton Styles */
          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }
          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }
          .rt-profile-modal .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }
          .rt-profile-modal .skeleton-cell {
            display: block !important;
            height: 13px !important;
            border-radius: 6px !important;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            ) !important;
            background-size: 600px 100% !important;
            animation: shimmer 1.4s ease-in-out infinite !important;
          }
          .rt-profile-modal .skeleton-cell.sk-short  { width: 40% !important; }
          .rt-profile-modal .skeleton-cell.sk-medium { width: 65% !important; }
          .rt-profile-modal .skeleton-cell.sk-long   { width: 85% !important; }
          .rt-profile-modal .skeleton-cell.sk-full   { width: 92% !important; }
          .rt-profile-modal .skeleton-row td {
            padding: 14px 16px !important;
            background: #ffffff !important;
            border-bottom: 1px solid #f1f5f9 !important;
          }
          .rt-profile-modal .wf-roles-empty-state {
            min-height: 250px !important;
            width: 100% !important;
          }
        `}</style>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-comments" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Customer Support Portal</span>
                      <span className="rt-modal-title-badge">
                        Support
                      </span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    {currentUser?.name && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" /> {currentUser.name}
                      </span>
                    )}
                    {currentUser?.id && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-hashtag" aria-hidden="true" /> Reg ID: {currentUser.id}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleIssueShowHide}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Page Show and Add Issue Button Card Section (Above Tab) */}
          {activeTab === "tickets" && !isRaisingTicket && (
            <div className="wf-card-header-bar">
              <div className="wf-header-left">
                <PageSizeOptions
                  pageSize={pageSize}
                  onChange={handlePageSizeChanged}
                />
                <span className="wf-stats-chip">
                  <i className="fa fa-ticket" aria-hidden="true" />
                  {totalCount} Total Tickets
                </span>
              </div>
              <div>
                <button
                  className="rt-password-submit-btn btn-sm"
                  onClick={handleRunApplication}
                  disabled={btnProcess}
                  style={{ padding: "7px 16px", fontSize: "12px", height: "auto" }}
                >
                  {btnProcess ? (
                    <i className="fa fa-spinner fa-spin mr-2"></i>
                  ) : (
                    <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                  )}{" "}
                  Add Issue
                </button>
              </div>
            </div>
          )}

          {/* Tab Navigation */}
          <div className="wf-tab-bar">
            <button
              type="button"
              className={`wf-tab-btn ${activeTab === "tickets" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("tickets");
                setShowHelpFirst(false);
              }}
            >
              <i className="fa fa-list-alt" aria-hidden="true" />
              Support Tickets
              <span className="wf-tab-badge">{supportTickets.length}</span>
            </button>
            <button
              type="button"
              className={`wf-tab-btn ${activeTab === "add_issue" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("add_issue");
                // If there's no active workflow, show start ticket screen
                if (!workflowTask && !btnProcess) {
                  setShowHelpFirst(false);
                }
              }}
            >
              <i className="fa fa-plus-circle" aria-hidden="true" />
              Raise Ticket
              {(workflowTask || btnProcess || showHelpFirst) && (
                <span className="wf-tab-badge" style={{ background: "rgba(37,99,235,0.1)", color: "#1d4ed8" }}>
                  Active
                </span>
              )}
            </button>
            <button
              type="button"
              className={`wf-tab-btn ${activeTab === "discussion" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("discussion");
                setShowHelpFirst(false);
              }}
            >
              <i className="fa fa-comments" aria-hidden="true" />
              Discussion
              {msgObj && (
                <span className="wf-tab-badge" style={{ background: "rgba(37,99,235,0.1)", color: "#1d4ed8" }}>
                  Active
                </span>
              )}
            </button>
          </div>

          <div className="wf-tab-panel-container">
            {activeTab === "tickets" && (
              <div className="wf-tab-panel">
                {/* Selected Context Card (Active Ticket for discussion) */}
                {msgObj && (
                  <div className="wf-assign-card" style={{ margin: "0 0 20px 0" }}>
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar" style={{ background: "linear-gradient(135deg, #2563eb, #7c3aed)" }}>
                        <i className="fa fa-ticket" aria-hidden="true" />
                      </div>
                      <div className="wf-assign-meta">
                        <strong>Ticket #{msgObj?.ciid}</strong>
                        <span>Issue: {getFieldData(msgObj?.stateData, "customersupportportal", "Issue_Name")}</span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        type="button"
                        className="btn-action-search btn-primary-search"
                        onClick={() => setActiveTab("discussion")}
                        style={{ height: "36px", display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px", fontWeight: "600" }}
                      >
                        <i className="fa fa-comments" aria-hidden="true" /> Go to Discussion
                      </button>
                      <button
                        type="button"
                        className="btn-action-search btn-danger-search"
                        onClick={() => handleMessagePopup(null)}
                        style={{ height: "36px", width: "36px", padding: 0, justifyContent: "center" }}
                        title="Deselect Ticket"
                      >
                        <i className="fa fa-times" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="row m-0">
                  <div className="col-md-12 p-0">
                    <div className="wf-table-scroll bg-white" style={{ position: "relative" }}>
                      {/* Pinned top border loading bar */}
                      {supportTicketsLoading && <div className="wf-loading-bar" />}

                      <table className="wf-table">
                        <thead className="wf-thead">
                          <tr>
                            <th>ID</th>
                            <th>Date & Time</th>
                            <th>Issue/Defect Name</th>
                            <th>Attachment</th>
                            <th>Status</th>
                            <th>Discussion</th>
                          </tr>
                        </thead>
                        <tbody>
                          {supportTicketsLoading ? (
                            Array.from({ length: pageSize }).map((_, idx) => (
                              <tr key={`skeleton-${idx}`} className="skeleton-row">
                                <td>
                                  <span className="skeleton-cell sk-short" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-medium" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-medium" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-long" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-short" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-short" />
                                </td>
                              </tr>
                            ))
                          ) : supportTickets.length === 0 ? (
                            <tr>
                              <td colSpan={6} style={{ padding: 0 }}>
                                <div className="wf-empty-state wf-roles-empty-state">
                                  <div className="wf-empty-icon">
                                    <i className="fa fa-list-alt" />
                                  </div>
                                  <p className="wf-empty-title">
                                    No Support Tickets Found
                                  </p>
                                  <p className="wf-empty-desc">
                                    There are no support tickets raised in this system yet. Once tickets are created they'll appear here.
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            supportTickets.map((item, key) => {
                              const isSelected = msgObj?.ciid === item.ciid;
                              return (
                                <tr
                                  key={item.ciid || key}
                                  className={`wf-table-row ${isSelected ? "selected-row" : ""}`}
                                  onClick={() => handleSelectTicketRow(item)}
                                >
                                  <td>
                                    <span style={{
                                      fontWeight: 600,
                                      color: isSelected ? "#2563eb" : "#1e293b",
                                      fontSize: "12px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px"
                                    }}>
                                      {isSelected && (
                                        <i className="fa fa-check-circle text-primary" style={{ fontSize: "12px" }} />
                                      )}
                                      #{item.ciid}
                                    </span>
                                  </td>
                                  <td>
                                    {item.startDateTime !== null && (
                                      <div className="d-flex align-items-start" style={{ gap: "8px" }}>
                                        <i className="fa fa-calendar-o" style={{ color: "#a855f7", fontSize: "14px", marginTop: "3px" }} aria-hidden="true" />
                                        <div className="d-flex flex-column" style={{ lineHeight: "1.3" }}>
                                          <span style={{ fontWeight: "600", color: "#334155", fontSize: "13px" }}>
                                            <Moment format="MMM Do YYYY">{item.startDateTime}</Moment>
                                          </span>
                                          <span style={{ color: "#64748b", fontSize: "12px", fontWeight: "500" }}>
                                            <Moment format="h:mm a">{item.startDateTime}</Moment>
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ fontWeight: "600", color: "#475569" }}>
                                    {getFieldData(
                                      item.stateData,
                                      "customersupportportal",
                                      "Issue_Name"
                                    )}
                                  </td>
                                  <td>
                                    {item.documents && item.documents.length > 0 ? (
                                      <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                                        {item.documents.map((doc) => (
                                          <span
                                            key={doc.documentUploadId || doc.documentName}
                                            className="badge-capsule badge-count"
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleDownloadFile(doc);
                                            }}
                                          >
                                            <i className="fa fa-paperclip" style={{ fontSize: "12px" }} />
                                            {doc.documentName}
                                          </span>
                                        ))}
                                      </div>
                                    ) : (
                                      <span className="badge-capsule badge-zero">None</span>
                                    )}
                                  </td>
                                  <td>
                                    {item.appApproved ? (
                                      <span className="rt-status-badge fixed">Fixed</span>
                                    ) : (
                                      <span className="rt-status-badge pending">Pending</span>
                                    )}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn-action-search"
                                      style={{
                                        padding: "7px 14px",
                                        fontSize: "12.5px",
                                        height: "36px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        background: "#ffffff",
                                        border: "1px solid #cbd5e1",
                                        borderRadius: "8px",
                                        fontWeight: "600",
                                        color: "#475569",
                                        whiteSpace: "nowrap"
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMessagePopup(item);
                                      }}
                                    >
                                      <i className="fa fa-comments-o" style={{ fontSize: "14px", color: "#64748b" }} />
                                      <span>View Chat</span>
                                      <span className="badge-capsule badge-zero" style={{ minWidth: "20px", height: "18px", display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0 4px", fontSize: "11px", marginLeft: "2px" }}>
                                        {(item.unreadCount || 0) + (item.readCount || 0)}
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-3">
                      <Pagination
                        currentPage={currentPage}
                        pageSize={pageSize}
                        itemsCount={totalCount}
                        onPageChange={handlePageChange}
                        startIndex={startIndex}
                        endIndex={endIndex}
                      ></Pagination>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "add_issue" && (
              <div className="wf-tab-panel">
                {!isRaisingTicket ? (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-ticket" aria-hidden="true" />
                    </div>
                    <h3 className="wf-empty-title">Raise a Support Ticket</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Encountered an issue or defect? Create a new support ticket and our customer support and technical team will review and resolve it.
                    </p>
                    <button
                      className="rt-password-submit-btn btn-sm mt-3"
                      onClick={handleRunApplication}
                    >
                      <i className="fa fa-plus mr-2" aria-hidden="true" />
                      Start New Ticket
                    </button>
                  </div>
                ) : isInitializingApp ? (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-spinner fa-spin" style={{ color: "#2563eb" }} />
                    </div>
                    <h3 className="wf-empty-title">Initializing Support Ticket...</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Please wait a moment while we set up the support session.
                    </p>
                    <button
                      className="btn-action-search btn-sm mt-3"
                      onClick={handleCancelAddIssue}
                      style={{ padding: "7px 16px", height: "auto" }}
                    >
                      Cancel & Back
                    </button>
                  </div>
                ) : showHelpFirst ? (
                  <div className="wf-tab-panel">
                    <div className="rt-support-welcome-card" style={{ background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 3px rgba(15, 23, 42, 0.03)", marginBottom: "20px" }}>
                      <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Welcome to our Customer Support Portal!</h3>
                      <p style={{ fontSize: "13.5px", color: "#475569", lineHeight: "1.6", marginBottom: "14px" }}>
                        In this portal we offer you an easy way to register any issue you may encounter while working and using various functions and features.
                      </p>
                      <p style={{ fontSize: "13.5px", color: "#475569", lineHeight: "1.6", marginBottom: "14px" }}>
                        Once you register an issue and submit, it will be received by our dedicated and committed customer and technical support staff who will review and provide instant fix(s), if required.
                      </p>
                      <p style={{ fontSize: "13.5px", color: "#475569", lineHeight: "1.6", marginBottom: "24px" }}>
                        Our customer and technical support staff will also update and notify you of the action taken.
                      </p>
                      <div className="support-signature">
                        <h4 style={{ margin: "0 0 4px 0", fontSize: "13.5px", fontWeight: "800", color: "#0f172a" }}>Thank you.</h4>
                        <h4 style={{ margin: "0 0 4px 0", fontSize: "13.5px", fontWeight: "800", color: "#2563eb" }}>WorkFINITY®</h4>
                        <h4 style={{ margin: "0", fontSize: "13.5px", fontWeight: "800", color: "#2563eb" }}>Customer and Technical Support</h4>
                      </div>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <button
                        className="rt-password-submit-btn btn-sm"
                        onClick={handleCloseAndProceed}
                        style={{ padding: "8px 20px" }}
                        disabled={btnProceedLoading}
                      >
                        {btnProceedLoading ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-2" />
                            Processing...
                          </>
                        ) : (
                          "Close & Proceed"
                        )}
                      </button>
                      <button
                        className="btn-action-search btn-sm"
                        onClick={handleCancelAddIssue}
                        style={{ padding: "7px 16px", height: "auto" }}
                        disabled={btnProceedLoading}
                      >
                        Cancel & Back
                      </button>
                    </div>
                  </div>
                ) : (workflowTask && wfForm) ? (
                  <div className="col-md-12 p-0">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#1e293b" }}>Active Support Form</h4>
                      <button
                        className="btn-action-search btn-danger-search btn-sm"
                        onClick={handleCancelAddIssue}
                        style={{ padding: "6px 14px", height: "auto", fontSize: "12px", display: "inline-flex", alignItems: "center", gap: "6px" }}
                      >
                        <i className="fa fa-times" /> Cancel & Back
                      </button>
                    </div>
                    <WorkflowElement
                      wfTask={workflowTask}
                      wfForm={wfForm}
                      handleNextTask={handleNextTask}
                      actionType={"workflow"}
                    />
                  </div>
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-spinner fa-spin" style={{ color: "#2563eb" }} />
                    </div>
                    <h3 className="wf-empty-title">Loading Active Support Form...</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Please wait while the active form loads.
                    </p>
                    <button
                      className="btn-action-search btn-sm mt-3"
                      onClick={handleCancelAddIssue}
                      style={{ padding: "7px 16px", height: "auto" }}
                    >
                      Cancel & Back
                    </button>
                  </div>
                )}
              </div>
            )}

            {activeTab === "discussion" && (
              <div className="wf-tab-panel">
                {msgObj ? (
                  <MessagingPopUpMod
                    msgShowHide={true}
                    message={msgObj}
                    handleMsgModalShowHide={() => handleMessagePopup(null)}
                    handleSendMessage={handleSendMessage}
                    handleSupportMessage={handleSupportMessage}
                    isInline={true}
                  />
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-comments-o" aria-hidden="true" />
                    </div>
                    <h3 className="wf-empty-title">No Active Discussion</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Please select a ticket from the Support Tickets tab and click "View/Reply" to read messages or write a reply.
                    </p>
                    <button
                      className="rt-password-submit-btn btn-sm mt-3"
                      onClick={() => setActiveTab("tickets")}
                    >
                      View Tickets
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleIssueShowHide}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Help
        helpShowHide={helpShowHide}
        handleHelpShowHide={handleHelpShowHide}
        module="Support"
      ></Help>
    </>
  );
};

export default SupportPupup;
